
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/[slug]",
      function () {
        return require("private-next-pages/solutions/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/[slug]"])
      });
    }
  